module.exports = __webpack_public_path__ + "img/HWC Roasters.849c6651.svg";